<!--  -->
<template>
  <div class="teaching-center-content">
    <gat-head
        class="Application-head"
    ></gat-head>

    <div class="QRCode-wrap">
      <img :src="QRCode" class="code" alt="">
      <p class="label">请扫描安装APP学习软件</p>
      <p class="label">开始学习哦</p>
      <!-- <div class="download-wrap">
        <span class="label">下载APP学习软件：</span>
        <a class="btn-down" :href="downUrl" ref="smsDownload" download>{{apkName}}</a>
      </div> -->
    </div>

    <!--页尾-->
    <gat-footer></gat-footer>

  </div>
</template>

<script>

export default {
  name: "teacherCenter",
  components: {},
  data() {
    return {
      // downUrl: "",
      apkName: "sms_prod.apk",
      QRCode: require("../../../public/images/QRCode/QRCode.png")
    };
  },
  computed: {},
  watch: {},
  created() {
    // this.downUrl = window.location.origin + "/sources/" + this.apkName;
    // console.log("this.downUrl",this.downUrl);

  },

  mounted() {

  },
  methods: {
    // downloadSms(e) {
    //   window.open(this.downUrl);
    // }
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  activated() {
  } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
.teaching-center-content {
  width: 100%;
  height: calc(100% - 80px);
  background: url("../../../public/images/home/code-bg.png") no-repeat;
  background-size: cover;
  background-position: center;
  color: $font_color_1st;
  padding-top: 80px;
}

.QRCode-wrap {
  position: absolute;
  min-width: 400px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  img {
    background: #fff;
    border-radius: 5px;
    padding: 10px;
  }

  .code {
    width: 210px;
    height: 210px;
    margin: 0 0 10px 0;
  }

  p.label {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 52px;
  }

  .download-wrap {
    margin: 30px 0 0 0;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #4AC7EB;

    a {
      color: #4AC7EB;
      //text-decoration:underline;
      border-bottom:2px solid #4AC7EB;
      padding-bottom:3px;
    }
  }
}

.gat-footer {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;

}
</style>
